export const getUserDepositsQuery = (destination: string, limit: number = 20) =>
  JSON.stringify({
    query: `
    query Deposits($destination: Bytes!) {
      deposits(
        first: ${limit}
        orderBy: timestamp
        orderDirection: desc
        where: { destination: $destination }
      ) {
        id
        tokenContract
        sender
        destination
        eventNonce
        amount
        timestamp
        blockHeight
      }
    }
  `,
    variables: {
      destination
    }
  })
